'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('@workmarket/front-end-components/dist/common/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseColors = _styles2.default.colors.baseColors;
var _default = {
	colors: baseColors
};
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(baseColors, 'baseColors', 'src/common/styles.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/common/styles.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/common/styles.js
// module id = kSyU
// module chunks = 62 63